// =============================================================
// Contract addresses per network.
// >>> FILL THESE IN. <<<  Leave the others as-is.
// The app reads the set that matches ACTIVE_NETWORK (app.config.js).
// =============================================================

export const CONTRACTS = {
  opbnbMainnet: {
    smartcorePurchase: "0x8De679B1531C49028716295F9aa695bCb6a44452",
    scnToken:          "0xBaF4ecB5e576e989B89cd0D5C84f91F341334aBE",
    scnDex:            "0x8d809557A5E19040EF0a8F3890964f8EAD08D0E3",
    usdt:              "0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3",
    // Block the SmartcoreNodePurchase contract was deployed at.
    // Used as the starting block for the activity (event) scan. 0 = fall back to recent window.
    deployBlock: 153366514,
  },

  opbnbTest: {
    smartcorePurchase: "0x9E49C79832cC1059f9F8e1f9c91EfB19E1CE696C",
    scnToken:          "0x8E1a4f77F94fa1707fEBb3441a6cc600Eb45BcB5",
    scnDex:            "0xEBc961CD38Bf6156f7B86d8A12725FA6c935FFbF",
    usdt:              "0xBf6596a279172D330b8b732D257Ee633B6FDA911",
    // Block the SmartcoreNodePurchase contract was deployed at.
    // Set this to the real deploy block for full activity history. 0 = recent window only.
    deployBlock: 0,
  },
};
